import React, { Component } from "react";
import { SubFormDefinition } from "./FormSet";
import FormSetWays from "./FormSetWays";

export interface FormSetProps {
    field?: any;
    form?: any;
    givenid: string;
    onChange?: (e) => void;
    formSetLabel?: string;
    subFormTypes: SubFormDefinition[];
    initialValues: any[];
    presets?: any[];
    extraFields?: any;
    subsidiary?: any;
    isConfig?: boolean;
    gameInstances?: any;
}

export default class BaseFormSetWays extends Component<FormSetProps, {}> {
    handleOnChange = formEvent => {
        this.props.form.setFieldValue(this.props.field.name, formEvent.values);
    };

    render() {
        return (
            <div id={this.props.givenid + "FormSet"}>
                <FormSetWays
                    onChange={this.handleOnChange}
                    subFormTypes={this.props.subFormTypes}
                    formSetLabel={this.props.formSetLabel}
                    initialValues={
                        this.props.field.value || this.props.initialValues
                    }
                    presets={this.props.presets}
                    extraFields={this.props.extraFields}
                    subsidiary={this.props.subsidiary}
                    isConfig={this.props.isConfig}
                    gameInstances={this.props.gameInstances}
                />
            </div>
        );
    }
}
